module.exports = __webpack_public_path__ + "static/media/popup_berhasil.20f4f5d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popup_berhasil.svg
// module id = 503
// module chunks = 0